export default __webpack_public_path__ + "static/media/skatelogo.466e4e1f.png";